const AUTH_BROADCAST_CHANNEL = 'auth';
const AUTH_BROADCAST_SOURCE_WINDOW_KEY = '__SCL_AUTH_BROADCAST_SOURCE_ID__';
let fallbackSourceId = null;
function createSourceId() {
    return `auth-${Math.random().toString(36).slice(2)}-${Date.now().toString(36)}`;
}
export function getAuthBroadcastSourceId() {
    try {
        const authWindow = window;
        const existing = authWindow[AUTH_BROADCAST_SOURCE_WINDOW_KEY];
        if (existing)
            return existing;
        const next = createSourceId();
        authWindow[AUTH_BROADCAST_SOURCE_WINDOW_KEY] = next;
        return next;
    }
    catch {
        if (!fallbackSourceId)
            fallbackSourceId = createSourceId();
        return fallbackSourceId;
    }
}
export function broadcastAuthEvent(event) {
    try {
        if (typeof window !== 'undefined' && 'BroadcastChannel' in window) {
            const bc = new BroadcastChannel(AUTH_BROADCAST_CHANNEL);
            bc.postMessage({ ...event, sourceId: getAuthBroadcastSourceId() });
            bc.close();
        }
    }
    catch {
        // ignore cross-tab sync failures
    }
}
//# sourceMappingURL=auth-broadcast.js.map